import { Component, OnInit } from '@angular/core';
import { ICity, IObject, IRegion } from '../../shared/models/models';
import { ServerService } from '../../shared/services/server.service';
import { EventService } from '../../shared/services/event.service';
import { UserInfo } from '../../components/header/header.component';
import { Router } from '../../../../node_modules/@angular/router';

@Component({
	selector: 'app-page-objects',
	templateUrl: './page-objects.component.html',
	styleUrls: [ './page-objects.component.scss' ]
})
export class PageObjectsComponent implements OnInit {
	objects: IObject[] = [];
	constObjects: IObject[] = [];

	cities: ICity[] = [];
	citiesLoading: number = 0;

	activeRegionId: number = null;
	activeCityId: number = null;

	loading: boolean = false;
	mapModal: boolean = false;

	user: UserInfo = null;

	errorMessage = '';
	objectRegion: IObject[] = [];
	menu = [ { id: 1, name: 'Все объекты' }, { id: 2, name: 'Строящиеся' }, { id: 3, name: 'Введенные' } ];
	selectedMenu;

	nameList: any;
	data: any;
	nameId: Number;

	constructor(private serverService: ServerService, private eventService: EventService, private router: Router) {}

	ngOnInit() {
		this.selectedMenu = 0;
		this.selectedValue = this.menu[0].name;
		let user = localStorage.getItem('user');
		this.loadObjects();
	}
	objectsEx: IObject[] = [];
	portalId = null;
	checkMioB: boolean = false;
	mioUser: boolean = false;
	loadObjects() {
		this.serverService.getObjects().then(
			(res) => {
				this.objects = res;
				this.objectRegion = res;
				this.constObjects = res;
				this.loading = true;
				let lastRegionId = localStorage.getItem('lastRegionId');
				if (lastRegionId) {
					let regionId = parseInt(lastRegionId);
					this.citiesLoading = 1;
					this.serverService.getCities(regionId).then((res) => {
						this.cities = res.filter((r) => r.livingComplexCount != 0);
						let lastCityId = localStorage.getItem('lastCityId');
						if (lastCityId) {
							if (Number.isInteger(parseInt(lastCityId))) {
								this.activeCityId = parseInt(lastCityId);
								this.cities.find((c) => c.id == this.activeCityId).active = true;
								this.objects = this.objects.filter((o) => o.region.id == this.activeRegionId);
								this.objectRegion = this.objectRegion.filter((o) => o.region.id == this.activeRegionId);
								this.objects = this.objects.filter((o) => o.city.id == this.activeCityId);
								this.objectRegion = this.objectRegion.filter((o) => o.city.id == this.activeCityId);
							} else {
								this.activeCityId = null;
								this.objects = this.constObjects.filter((o) => o.region.id == this.activeRegionId);

								this.objectRegion = this.constObjects.filter((o) => o.region.id == this.activeRegionId);
							}
						}
						this.citiesLoading = 2;
					});
					this.activeRegionId = regionId;
					this.objects = this.constObjects;
					this.objects = this.objects.filter((o) => o.region.id == regionId);

					this.objectRegion = this.constObjects;
					this.objectRegion = this.objectRegion.filter((o) => o.region.id == regionId);
				}
        let NotReal = localStorage.getItem('Real');
       this.objectsEx = this.objects;
				if (NotReal === 'NotReal') {
					this.objects = this.objectsEx.filter(r => r.constProgressEnd === false);
				}

				if (NotReal === 'Real') {
          this.objects = this.objectsEx.filter(r => r.constProgressEnd === true);

				}

				let user = localStorage.getItem('user');
				if (user) {
					this.user = JSON.parse(user);
					this.user.roles.map((r) => {
						if (r === 'BDAdmin') {
							this.checkMioB = true;
						}
						// if(r === "MioUser" || this.user.region.length > 0 ) {
						//   this.mioUser = true;
						// }
					});
					if (!this.checkMioB) {
						let regionId = this.user.region[0].id;
						this.citiesLoading = 1;
						this.serverService.getCities(regionId).then((res) => {
							this.cities = res.filter((r) => r.livingComplexCount != 0);
							this.citiesLoading = 2;
						});
						this.activeRegionId = regionId;
						this.objects = this.constObjects;
						this.objects = this.objects.filter((o) => o.region.id == regionId);

						this.objectRegion = this.constObjects;
						this.objectRegion = this.objectRegion.filter((o) => o.region.id == regionId);
					}
				}

				this.eventService.chooseRegionEvent.subscribe((regionId) => {
					this.citiesLoading = 1;
					this.serverService.getCities(regionId).then((res) => {
						this.cities = res.filter((r) => r.livingComplexCount != 0);
						this.citiesLoading = 2;
					});
					this.activeRegionId = regionId;
					this.objects = this.constObjects;
					this.objects = this.objects.filter((o) => o.region.id == regionId);
					this.objectRegion = this.constObjects;
					this.objectRegion = this.objectRegion.filter((o) => o.region.id == regionId);
				});
				// let objectType = localStorage.getItem("objects");
				// if (objectType === "mio") {
				//   this.objects = [];

				//   this.objects = this.constObjects.filter(r => r.portalID === 1);

				//   this.portalId = 1;
				//   localStorage.removeItem("objects");
				// }
				// if (objectType === "bd") {
				//   this.objects = [];
				//   this.objects = this.constObjects.filter(r => r.portalID === 2);

				//   this.portalId = 2;
				//   localStorage.removeItem("objects");
				// }
			},
			(err: any) => {
				if (err.status == 500 || err.status == 0) {
					this.errorMessage =
						'К сожалению, сервер временно недоступен. Попробуйте повторить действие чуть позже';
					this.loading = true;
				}
				if (err.status == 401) {
					alert('Истекло время вашего сеанса! \nВас перенаправит на главную страницу, чтобы заново зайти!');
					localStorage.clear();
					return this.router.navigate([ '/login' ]);
				}
			}
		);
	}

	setCity(city: ICity) {
		this.selectedValue = this.menu[0].name;
		if (city.active !== true) {
			this.selectedMenu = 0;
			this.cities.forEach((c) => (c.active = false));
			city.active = true;
			this.activeCityId = city.id;
			localStorage.setItem('lastCityId', this.activeCityId.toString());
			this.objects = this.constObjects;
			this.objects = this.objects.filter((o) => o.region.id == this.activeRegionId);
			this.objects = this.objects.filter((o) => o.city.id == city.id);

			this.objectRegion = this.constObjects;
			this.objectRegion = this.objectRegion.filter((o) => o.region.id == this.activeRegionId);
			this.objectRegion = this.objectRegion.filter((o) => o.city.id == city.id);
		} else {
			this.selectedMenu = 0;
			this.activeCityId = null;
			localStorage.setItem('lastCityId', null);
			this.cities.forEach((c) => (c.active = false));
			this.objects = this.constObjects.filter((o) => o.region.id == this.activeRegionId);
			this.objectRegion = this.constObjects.filter((o) => o.region.id == this.activeRegionId);
		}
	}

	resetFilters() {
		this.selectedValue = this.menu[0].name;
		this.activeCityId = null;
		localStorage.setItem('lastCityId', null);
		this.cities.forEach((c) => (c.active = false));
		this.objects = this.constObjects.filter((o) => o.region.id == this.activeRegionId);
		this.objectRegion = this.constObjects.filter((o) => o.region.id == this.activeRegionId);
	}

	trackByObject(index, object: IObject) {
		return object.id;
	}
	underConstruction() {
		this.selectedValue = this.menu[1].name;

    this.objectsEx = [];
		this.objectRegion.forEach((r) => {
			if (r.completion_percent !== 100 || r.constProgressEnd === false) {
				this.objectsEx.push(r);
				this.objects = this.objectsEx;
			}
		});
	}

	afterConstruction() {
    this.selectedValue = this.menu[2].name;

    this.objectsEx = [];
		this.objectRegion.forEach((r) => {
			if (r.completion_percent === 100 && r.constProgressEnd === true) {
        this.objectsEx.push(r);
        this.objects = this.objectsEx;
			}
		});
	}



	selectedValue: string;
	showValues: boolean = false;
	showAll() {
		this.showValues = !this.showValues;
	}
	selectedValueBtn(selectedValue) {
		if (selectedValue === 1) {
			this.resetFilters();
			this.showAll();
		}

		if (selectedValue === 2) {
			this.underConstruction();
			this.showAll();
		}

		if (selectedValue === 3) {
			this.afterConstruction();
			this.showAll();
		}
	}

	downloadReport() {
		if(this.activeCityId) {
		  this.serverService.downloadReport(null, this.activeCityId, null);
		} else {
		  this.serverService.downloadReport(this.activeRegionId, null, null);
		}

	  }
}
